import { useState } from 'react';
import { WorkbookPage, SectionTitle } from '@/components/WorkbookPage';
import { CreditCard, CheckCircle2 } from 'lucide-react';

export const CreditChecklistPage = () => {
  const [items, setItems] = useState([
    { text: 'I know my current credit score', checked: false },
    { text: 'I\'ve reviewed my credit report in the past year (AnnualCreditReport.com)', checked: false },
    { text: 'I pay at least the minimum on all accounts by the due date', checked: false },
    { text: 'I keep credit utilization under 30%', checked: false },
    { text: 'I have autopay set up for at least minimum payments', checked: false },
    { text: 'I avoid opening multiple new accounts in a short time', checked: false },
    { text: 'I check for errors on my credit report', checked: false },
    { text: 'I understand how credit cards work and use them wisely', checked: false },
    { text: 'I pay my full credit card balance when possible', checked: false },
    { text: 'I have a plan for improving/maintaining my credit score', checked: false },
  ]);
  
  const toggleItem = (index) => {
    const newItems = [...items];
    newItems[index].checked = !newItems[index].checked;
    setItems(newItems);
  };
  
  const completedCount = items.filter(i => i.checked).length;
  
  return (
    <WorkbookPage pageId="credit-checklist" prevPage="debt-tracker" nextPage="emergency-tracker">
      <header className="mb-10">
        <div className="flex items-center gap-3 mb-4">
          <CreditCard className="h-6 w-6 text-primary" />
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-foreground">
            Credit Health Checklist
          </h1>
        </div>
        <p className="text-muted-foreground">
          Track your credit health habits
        </p>
      </header>
      
      {/* Progress */}
      <div className="mb-8">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium">Progress</span>
          <span className="text-sm text-muted-foreground">{completedCount}/{items.length}</span>
        </div>
        <div className="h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-primary rounded-full transition-all duration-500"
            style={{ width: `${(completedCount / items.length) * 100}%` }}
          />
        </div>
      </div>
      
      {/* Checklist */}
      <div className="space-y-3">
        {items.map((item, index) => (
          <button
            key={index}
            onClick={() => toggleItem(index)}
            className={`w-full flex items-start gap-4 p-4 rounded-lg border-2 transition-all text-left ${
              item.checked
                ? 'bg-success/5 border-success/30'
                : 'bg-card border-border hover:border-primary/30'
            }`}
          >
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 mt-0.5 ${
              item.checked ? 'bg-success border-success' : 'border-border'
            }`}>
              {item.checked && <CheckCircle2 className="h-4 w-4 text-white" />}
            </div>
            <span className={`text-sm ${item.checked ? 'text-muted-foreground line-through' : ''}`}>
              {item.text}
            </span>
          </button>
        ))}
      </div>
      
      <div className="mt-8 bg-muted/50 rounded-lg p-5">
        <SectionTitle>My Credit Score</SectionTitle>
        <div className="grid md:grid-cols-3 gap-4 mt-4">
          <div>
            <label className="block text-xs text-muted-foreground mb-1">Current Score:</label>
            <input
              type="text"
              className="w-full bg-card border border-border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="___"
            />
          </div>
          <div>
            <label className="block text-xs text-muted-foreground mb-1">Goal Score:</label>
            <input
              type="text"
              className="w-full bg-card border border-border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="___"
            />
          </div>
          <div>
            <label className="block text-xs text-muted-foreground mb-1">Date Checked:</label>
            <input
              type="text"
              className="w-full bg-card border border-border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="MM/DD/YY"
            />
          </div>
        </div>
      </div>
    </WorkbookPage>
  );
};
